import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/typography';
import { safeOpenJarabot } from '@/utils/jarabot';
import Image from 'next/image';
import { Link } from '@/components/links';
import { CONTACT_EMAIL } from '@/constants/contacts';
import IconMail from '@/assets/icons/heroIcons/Mail.svg';
import IconQuestionMarkCircle from '@/assets/icons/heroIcons/QuestionMarkCircle.svg';
function ChatboxSection() {
  const $ = _c(40);
  const {
    t
  } = useTranslation("contact");
  let t0;
  if ($[0] !== t) {
    t0 = t("contacts.chatbox.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="mb-4 text-lg font-semibold md:text-2xl">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("contacts.chatbox.text");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <Text variant="p3" className="mb-4">{t2}</Text>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("contacts.chatbox.cta");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <Button variant="primary" testId="openChat" analyticsParam="openChat" onClick={safeOpenJarabot}>{t4}</Button>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
    t6 = <div className="flex-1 py-8">{t1}{t3}{t5}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("contacts.chatbox.alt");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <div className="md:shring-0 flex w-full flex-col items-center justify-center md:w-[264px]"><Image src="/images/sections/contact/chat.png" width={156} height={174} alt={t7} /></div>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <div className="rounded-2xl bg-white px-8 md:flex-1"><div className="flex flex-col gap-4 md:flex-row">{t6}{t8}</div></div>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t) {
    t10 = t("contacts.other.title");
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10) {
    t11 = <p className="m-0 text-lg font-semibold md:text-2xl">{t10}</p>;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Link to={`mailto:${CONTACT_EMAIL}`} analyticsParam="contactEmail" testId="contactEmail"><span className="flex flex-row items-center gap-2"><IconMail className="h-7 w-7 text-blue-500" /><span>{CONTACT_EMAIL}</span></span></Link>;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = LINKS();
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = t13.faq;
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconQuestionMarkCircle className="h-7 w-7 text-blue-500" />;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t("contacts.other.faq");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16) {
    t17 = <Link testId="contactFaq" analyticsParam="contactFaq" to={t14}><span className="flex flex-row items-center gap-2">{t15}<span>{t16}</span></span></Link>;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t11 || $[35] !== t17) {
    t18 = <div className="flex flex-col gap-4 rounded-2xl bg-white p-8 lg:w-[34%] lg:shrink-0">{t11}{t12}{t17}</div>;
    $[34] = t11;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t18 || $[38] !== t9) {
    t19 = <div className="flex flex-col gap-6 lg:flex-row">{t9}{t18}</div>;
    $[37] = t18;
    $[38] = t9;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
}
export default ChatboxSection;